import './Description.css'

interface Props {
    content: string
}

const Description: React.FC<Props> = (props) => {
    return (
        <div className="blog-description" dangerouslySetInnerHTML={{ __html: props.content }}></div>
    )
}

export default Description